import React, {useEffect, useState} from "react";
// import { Line } from "react-chartjs-2";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
);


const LineChart = ({data}) => {
	// const proyects = useSelector(state => state.proyects);
	const [filteredData, setFilteredData] = useState({labels: [], datasets: []});
	

	useEffect(() => {
		if (data && data[0] !== undefined) {
			let dataset = [];
			for (let i = 0; i < data.length; i++) {
				if ( !data[i].EjeY ) {
					continue;
				}
				const element = data[i].EjeY.split('|');
				const label = ["Programado", "Valorizado", "Real" ].indexOf(element[0]) >= 0 
								? element[0]
								: 'labels';
				dataset[label] = element.slice(label === "labels" ? 0 : 1);
			}
			// var Programado = data[1] ? data[1].EjeY.split('|').filter(function(value, index, arr){ return value > 1;}) : [];
			// var Real = data[2] ? data[2].EjeY.split('|').filter(function(value, index, arr){ return value > 1;}) : [];
			// var Valorizado = data[3] ? data[3].EjeY.split('|').filter(function(value, index, arr){ return value > 1;}) : [];
			const filteredData = {
				labels: dataset["labels"] ? dataset["labels"] : [],
				
				datasets: [
				  {
					label: "Programado",
					data: dataset["Programado"] ? dataset["Programado"] : [],
					fill: false,
					backgroundColor: "#0000ff25",
					borderColor: "#367fa9",
				  },
				  {
					label: "Valorizado" ,
					data: dataset["Valorizado"] ? dataset["Valorizado"] : [],
					fill: false,
					backgroundColor: "#E1C340",
					borderColor: "#f2a744",
				  },
			  
				  {
					label: "Real" ,
					data: dataset["Real"] ? dataset["Real"] : [],
					fill: true,
					backgroundColor: "#00ffff3c",
					borderColor: "#36bea1",
				  },
				],
			};
			setFilteredData(filteredData);
		}
	}, [data]);
	
	  
	const options = {
		responsive: true,
		plugins: {
		  legend: {
			display: false
		  }
		},
		scales: {
		  y: {
			beginAtZero: true
		  }
		}
	};
	//if (data[1] === undefined) return <label>Sin data</label>;
	  
	return(
		<div className="responsive-chart">
			<Line data={filteredData} options={options} className="maxandmin" />
		</div>
	)
 
};

export default LineChart;
